import React from 'react'
import { MdCheck } from 'react-icons/md';
import { Button } from 'react-bootstrap';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

export default class ListAlertAdminComponent extends React.Component {

    checkedAlertAdmin = (e) => {
        if ( e.nativeEvent.shiftKey ) {
            let value = e.target.checked;
            this.props.checkedAlertAdminShiftKey( this.props.actionKey, value );
        } else {
            this.props.checkedAlertAdmin( this.props.actionKey );
        }
    }

	render() {
		return (
			<tr>
				<td className="text-center alert-admin-selected">
                    <input 
                    	type="checkbox" 
                    	checked={this.props.alert.checked}  
                    	onChange={ this.checkedAlertAdmin } 
                    />
                </td>
				<td>#{ this.props.alert.id }</td>
				<td>
					<div dangerouslySetInnerHTML={{ __html: this.props.alert.service_text }} />
				</td>
				<td>{ this.props.alert.error_text }</td>
				<td>{ this.props.alert.dateCreated }</td>
				<td>
					<OverlayTrigger
                        overlay={(props) => (
                            <Tooltip {...props}>
                                Xác nhận hoàn thành cảnh báo
                            </Tooltip>
                        )}
                        placement="top"
                    >
						<Button 
	    					className="btn btn-success btn-sm m-1"
							onClick={ () => this.props.confirm(this.props.alert.id) }
						>
							<MdCheck />
					  	</Button>
				  	</OverlayTrigger>
				</td>
			</tr>
		)
	}
}